import {FACTIONS} from "../constants/factions";

export const FACTION_INSECTOIDS_MOCK_FARM_HEX_KEY = FACTIONS.INSECTOIDS + '_mock_farm'